module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item hidden-lg-down",
    staticStyle: {
      "width": "400px",
      "margin-right": "10px"
    }
  }, [_c('form', {
    staticClass: "app-search",
    attrs: {
      "role": "search"
    }
  }, [_c('el-select', {
    staticClass: "form-control",
    attrs: {
      "id": "global-search",
      "filterable": "",
      "remote": "",
      "clearable": "",
      "remote-method": _vm.searchCustomer,
      "placeholder": "Rechercher une fiche dans toute l'interface ..."
    },
    on: {
      "change": _vm.handleChange,
      "clear": _vm.handleClear
    },
    model: {
      value: (_vm.customer_id),
      callback: function($$v) {
        _vm.customer_id = $$v
      },
      expression: "customer_id"
    }
  }, _vm._l((_vm.customers), function(customer) {
    return _c('customer', {
      key: customer.id,
      attrs: {
        "item": customer,
        "present": "option"
      }
    })
  }), 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c07d16e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Templates/TopBar/TopBarSearch.vue
// module id = 725
// module chunks = 1